import Vue from 'vue'
import router from '@/router'
import '@/util/format';
import '@/util/number';
import '@/util/object';
import '@/plugins/ajax'
import '@/plugins/weui'
import '@/plugins/editor'
import '@/directives/config'
import '@/style/common.css'
import '@/style/icon.css'
import App from './App.vue'

Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-app', 'wx-open-launch-weapp']
Vue.prototype.$bus = new Vue();

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
